import React from "react"
import {Link} from 'react-router-dom'

const Edit=({route})=> {
    

    return (
      <>
      <Link to={route}> <i style={{color:'#f7931a'}} className="fas fa-pen"></i></Link>
      </>
    )
  }

export default Edit;